import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Link } from 'react-admin';
import { Typography } from '@material-ui/core';
import { coreWalletTypeToResourceMapping } from '../../coreWalletTypes';

const LinkField = ({ source, record = {}, type, id, resource, mappingDictionary }) => {
	const typeToUse = type || get(record, source + '.type');
	const idToUse = id || get(record, source + '.id') || get(record, source);
	const mapping = mappingDictionary[typeToUse];
	return typeToUse && idToUse ? (
		mapping ? (
			<Link to={`/${mapping}/${idToUse}/show`}>
				<Typography variant="body2">{typeToUse} {idToUse}</Typography>
			</Link>
		) : (
			<Typography variant="body2">{typeToUse} {idToUse}</Typography>
		)
	) : null;
};

LinkField.propTypes = {
	label: PropTypes.string,
	record: PropTypes.object,
	source: PropTypes.string,
	resource: PropTypes.string,
	type: PropTypes.string,
	id: PropTypes.string,
	mappingDictionary: PropTypes.object
};

LinkField.defaultProps = {
	addLabel: true,
	mappingDictionary: coreWalletTypeToResourceMapping
};

export default LinkField;
